import { useEffect } from 'react';

interface ExternalRedirectProps {
  to: string;
}

export const ExternalRedirect: React.FC<ExternalRedirectProps> = ({ to }) => {
  useEffect(() => {
    const currentParams = new URLSearchParams(window.location.search);
    const destinationUrl = new URL(to, window.location.origin);

    currentParams.forEach((value, key) => {
      if (!destinationUrl.searchParams.has(key)) {
        destinationUrl.searchParams.append(key, value);
      }
    });

    window.location.href = destinationUrl.toString();
  }, [to]);

  return null;
};
